import { loaders } from "@dinahmoe/dmafjs-assetloader";
import { webAudioLoader } from "./webaudio";

loaders.addType("webaudio", webAudioLoader);
